import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import {Link, useParams, useNavigate} from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName, formatDateTime} from '../Univ.js'
function AddEmployee() {
  const navigate = useNavigate();

  const [errorMsg, seterrorMsg] = useState('');
  const [selectedDate, setSelectedDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
  const [selectedAgeDate, setSelectedAgeDate] = useState(new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000));
  const [gender, setGender] = useState("male");
  const [succesMsg, setsuccessMsg] = useState('');
  const [empData, setempData] = useState([]);
  const [desg, setDesg] = useState([]);
  const [dept, setDept] = useState([]);
  const [selectedImage, setSelectedImage] = useState(null);
  const [registerFormData, setRegisterFormData] = useState({
    emp_id: '',
    emp_code: '',
    employee: '',
    gender: '',
    employee_pic: '',
    age: '',
    mobile: '',
    address: '',
    marital: '',
    blood: '',
    religion: '',
    alt_contact: '',
    email: '',
    adhar: '',
    pan: '',
    passport: '',
    emp_status: '',
    doj: '',
    education: '',
    experience: '',
    department: '',
    designation: '',
    account: '',
    branch: '',
    esi: '',
    pf: '',
    basic: '',
    hra: '',
    allowance: '',
    spl: '',
    other_earn: '',
    earnings: '',
    prof: '',
    tds: '',
    other_deduct: '',
    empf: '',
    emesi: '',
    elpf: '',
    elesi: '',
    deduction: '',
    ctc: '',
  });
  useEffect(() => {
    fetchData();
  }, []);
  function fetchData() {
    axios.get(`${baseUrl}add-dept/`)
      .then(response => {
        setDept(response.data);
      })
      .catch(error => {
        console.log(error);
      });
      axios.get(`${baseUrl}add-designation/`)
      .then(response => {
        setDesg(response.data);
      });
  }
   const handleDateChange = (date) => {
        setSelectedDate(date);
    };
    const handleAgeDateChange = (date) => {
        setSelectedAgeDate(date);
    };
  const handleInputChange = (event) => {
    setGender(event.target.value);
  };
  
   const inputHandler = (e) => {
    const { name, value } = e.target;
    setRegisterFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const calculateEarnings = () => {
    const { basic, hra, allowance, spl, other_earn } = registerFormData;

    const empf = (basic * (12 / 100)).toFixed(2);
    const earnings = parseFloat(basic) + parseFloat(hra) + parseFloat(allowance) + parseFloat(spl) + parseFloat(other_earn);

    let emesi = 0;
    if (earnings <= 21000) {
      emesi = (earnings * (0.75 / 100)).toFixed(2);
    }else{
      emesi = 0;
    }
    setRegisterFormData((prevState) => ({
      ...prevState,
      empf,
      emesi,
      earnings,
    }));
  };
  const calculateDeduction = () => {
    const { emesi, empf, prof, tds, other_deduct } = registerFormData;
    const deduction = parseFloat(prof) + parseFloat(tds) + parseFloat(other_deduct) + parseFloat(empf) + parseFloat(emesi);

    setRegisterFormData((prevState) => ({
      ...prevState,
      deduction,
    }));
  };
  const calculateCtc = () => {
  const { earnings, deduction } = registerFormData;
  const ctc = parseFloat(earnings) - parseFloat(deduction);
      setRegisterFormData((prevState) => ({
        ...prevState,
        ctc,
      }));
  };

  useEffect(() => {
    if (registerFormData.basic !== '') {
      calculateEarnings();
      calculateDeduction();
      calculateCtc();
    }
  }, [registerFormData]);

    const handleFileChange = (event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]:event.target.files[0]
        });
        const file = event.target.files[0];
        if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setSelectedImage(e.target.result);
      };
      reader.readAsDataURL(file);
    }
    }


  const submitHandler = (e) => {
    e.preventDefault();
        const formData = new FormData();
        const emp_status = document.getElementById("emp_status").value;
        const department = document.getElementById("department").value;
        const designation = document.getElementById("designation").value;
        const formattedDate = moment(selectedDate).format('YYYY-MM-DD');
        axios.post(`${baseUrl}get_emp_id/`)
          .then(response => {
        const empId = response.data.value;
        formData.append('emp_id',registerFormData.emp_id);
        formData.append('emp_code',empId);
        formData.append('employee',registerFormData.employee);
        formData.append('gender',gender);
        formData.append('emp_status',emp_status);
        formData.append('age',registerFormData.age);
        formData.append('mobile',registerFormData.mobile);
        formData.append('address',registerFormData.address);
        formData.append('marital',registerFormData.marital);
        formData.append('blood',registerFormData.blood);
        formData.append('religion',registerFormData.religion);
        formData.append('alt_contact',registerFormData.alt_contact);
        formData.append('email',registerFormData.email);
        formData.append('adhar',registerFormData.adhar);
        formData.append('pan',registerFormData.pan);
        formData.append('passport',registerFormData.passport);
        formData.append('education',registerFormData.education);
        formData.append('experience',registerFormData.experience);
        formData.append('account',registerFormData.account);
        formData.append('branch',registerFormData.branch);
        formData.append('esi',registerFormData.esi);
        formData.append('pf',registerFormData.pf);
        formData.append('basic',registerFormData.basic);
        formData.append('hra',registerFormData.hra);
        formData.append('allowance',registerFormData.allowance);
        formData.append('spl',registerFormData.spl);
        formData.append('other_earn',registerFormData.other_earn);
        formData.append('earnings',registerFormData.earnings);
        formData.append('prof',registerFormData.prof);
        formData.append('tds',registerFormData.tds);
        formData.append('other_deduct',registerFormData.other_deduct);
        formData.append('empf',registerFormData.empf);
        formData.append('emesi',registerFormData.emesi);
        formData.append('elpf',registerFormData.empf);
        formData.append('elesi',registerFormData.emesi);
        formData.append('deduction',registerFormData.deduction);
        formData.append('ctc',registerFormData.ctc);

        if (registerFormData.f_files !== null && registerFormData.f_files !== undefined && registerFormData.f_files !== '') {
          formData.append('employee_pic', registerFormData.f_files, registerFormData.f_files.name);
        }
        formData.append('doj',formattedDate);
        formData.append('department',department);
        formData.append('designation',designation);
        formData.append('addedby', userName);
        formData.append('status', '1');
        formData.append('ip_add', ipAddress);
          formData.append('location', userLocation);
        axios.post(`${baseUrl}add-employee/`, formData)
        .then(response1 => {
            if(response1.status==200 || response1.status==201){
                Swal.fire({
                  title: 'Employee Registeration Done.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/emp-list';
                }, 3000);
            }
            })
            .catch(error => {
              console.log(error);
              Swal.fire(
                'Error!',
                'Failed. Please try again later.',
                'error'
              );
          });
        })
  };

  return (
        <section className="container mt-4">
            <div className="row">
              <div className="col-md-10 col-12 offset-1">
                <div className='card'>
                    <h4 className='card-header text-center'>Add Employee</h4>
                    <div className='card-body'>
                        <p className="text-muted"><strong>Note:</strong>All are Mandatory Fields</p>
                        {succesMsg && <p className="text-success">{succesMsg}</p>}
                        {errorMsg && <p className="text-danger">{errorMsg}</p>}
                        <form>                        
                        <div>
                        <div className="row">
                        <label htmlFor="Role" className="form-label">Employee Name</label>

                        <div className="col-md-3 mb-3">
                        <input type="text"  className="form-control" placeholder="Employee ID"
                           name="emp_id"
                           id="emp_id"
                           value={registerFormData.emp_id}
                           onChange={inputHandler} />
                       <input type="text" placeholder="Employee Name" className="form-control"
                           name="employee"
                           id="employee"
                           value={registerFormData.employee}
                           onChange={inputHandler}
                           />
                        </div>
                        <div className="col-md-4 mb-3">
                        <label htmlFor="Gender" className="form-label">Gender</label>
                            <label className="radio-inline">
                            <input type="radio" name="gender" value="male" checked={gender === "male"}
                             onChange={handleInputChange}/> Male
                            </label>
                            <label className="radio-inline">
                            <input type="radio" name="gender" value="female" checked={gender === "female"}
                             onChange={handleInputChange} /> Female
                            </label>
                            <label className="radio-inline">
                            <input type="radio" name="gender" value="transgender" checked={gender === "transgender"}
                             onChange={handleInputChange} /> Transgender
                            </label>
                        </div>
                        <div className="col-md-3 mb-2">
                        {selectedImage && (
                        <>
                        <img src={selectedImage} alt="Thumbnail" className="thumbnail" style={{width:120, height:60}}/>
                        </>
                        )}
                        <input type="file" className="form-control" name="f_files"
                        onChange={handleFileChange} id="f_files" accept="image/*"/>
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Date" className="form-label">Date of Birth</label>
                        <DatePicker className="form-control" name="age" id="age" selected={selectedAgeDate}
                            onChange={handleAgeDateChange}
                            dateFormat="yyyy-MM-dd"
                            showMonthDropdown
                            showYearDropdown
                        />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="Mobile" className="form-label">Mobile</label>
                            <input type="tel" pattern="[0-9]{10}" maxLength={10} placeholder="Mobile" className="form-control"
                                name="mobile"
                                value={registerFormData.mobile}
                                onChange={inputHandler} />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label htmlFor="Address" className="form-label">Address</label>
                            <input type="text" placeholder="Address" className="form-control"
                               name="address"
                               value={registerFormData.address}
                               onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Marital" className="form-label">Marital Status</label>
                            <select className="form-control"
                            value={registerFormData.marital}
                            onChange={inputHandler}
                              name="marital" id="marital" >
                            <option value="single">Single</option>
                            <option value="married">Married</option>
                            <option value="unmarried">Un Married</option>
                            </select>
                        </div>
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Blood Group" className="form-label">Blood Group</label>
                            <select className="form-control"
                            value={registerFormData.blood}
                            onChange={inputHandler}
                              name="blood" id="blood" >
                            <option value="O+">O+</option>
                            <option value="O-">O-</option>
                            <option value="B+">B+</option>
                            <option value="B-">B-</option>
                            <option value="A+">A+</option>
                            <option value="A-">A-</option>
                            <option value="AB+">AB+</option>
                            <option value="AB-">AB-</option>
                            </select>
                        </div>
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Religion" className="form-label">Religion</label>
                        <input type="text" maxLength={10} placeholder="Religion" className="form-control"
                            name="religion" id="religion"
                            onChange={inputHandler} />
                        </div>
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Alt No" className="form-label">Alternate No</label>
                        <input type="tel" pattern="[0-9]{10}" maxLength={10} placeholder="Alt No" className="form-control"
                            name="alt_contact" id="alt_contact"
                            onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-3 mb-3">
                            <label htmlFor="Email" className="form-label">Email</label>
                            <input type="email" placeholder="Email" className="form-control"
                               name="email" id="email" value={registerFormData.email} onChange={inputHandler} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="Aadhar" className="form-label">Aadhar</label>
                            <input type="number" placeholder="Aadhar" className="form-control" maxLength={16}
                               name="adhar" id="adhar" value={registerFormData.adhar} onChange={inputHandler} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="PAN No" className="form-label">PAN No</label>
                            <input type="text" placeholder="PAN No" className="form-control" maxLength={16}
                               name="pan" id="pan" value={registerFormData.pan} onChange={inputHandler} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="Aadhar" className="form-label">Passport No</label>
                            <input type="text" placeholder="Passport No" className="form-control" maxLength={20}
                               name="passport" id="passport" value={registerFormData.passport} onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Status" className="form-label">Employment Status</label>
                            <select className="form-control" value={registerFormData.emp_status} onChange={inputHandler}
                              name="emp_status" id="emp_status">
                            <option >Select Employee Status</option>
                            <option value="Permanent">Permanent</option>
                            <option value="Contract">Contract</option>
                            <option value="Trainee">Trainee</option>
                            </select>
                        </div>
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Date" className="form-label">Date of Joining</label>
                        <DatePicker className="form-control" name="doj" id="doj" selected={selectedDate}
                            onChange={handleDateChange}
                            dateFormat="yyyy-MM-dd"
                        />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="education" className="form-label">Education Qualification</label>
                            <input type="text" placeholder="Education Qual" className="form-control" maxLength={20}
                               name="education" id="education" value={registerFormData.education} onChange={inputHandler} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="Aadhar" className="form-label">Experience</label>
                            <input type="text" placeholder="Experience" className="form-control" maxLength={20}
                               name="experience" id="experience" value={registerFormData.experience} onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-6 mb-3">
                        <label htmlFor="Department" className="form-label">Department</label>
                              <select className="form-control" value={registerFormData.department} onChange={inputHandler}
                                name="department" id="department">
                                {dept.map((department,index) => {return <option key={index} value={department.id}>{department.department}
                                </option>})}
                              </select>
                        </div>
                        <div className="col-md-6 mb-3">
                        <label htmlFor="Designation" className="form-label">Designation</label>
                              <select className="form-control" value={registerFormData.designation} onChange={inputHandler}
                                name="designation" id="designation">
                                {desg.map((designation,index) => {return <option key={index} value={designation.id}>{designation.designation}
                                </option>})}
                              </select>
                        </div>
                        </div>
                        <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <i className="fa-solid fa-indian-rupee-sign" aria-hidden="true" style={{ color: 'red' }}></i>
                          Account Details
                        </h3>
                         <div className="row">
                        <div className="col-md-3 mb-3">
                            <label htmlFor="Account No" className="form-label">Bank Account No</label>
                            <input type="text" placeholder="Account No" className="form-control"
                               name="account" id="account" value={registerFormData.account} onChange={inputHandler} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="Bank Branch Detail" className="form-label">Bank Branch Detail</label>
                            <input type="text" placeholder="Bank Branch Detail" className="form-control" maxLength={16}
                               name="branch" id="branch" value={registerFormData.branch} onChange={inputHandler} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="ESI No" className="form-label">ESI No</label>
                            <input type="text" placeholder="ESI No" className="form-control" maxLength={16}
                               name="esi" id="esi" value={registerFormData.esi} onChange={inputHandler} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="PF No" className="form-label">PF No</label>
                            <input type="text" placeholder="PF No" className="form-control" maxLength={20}
                               name="pf" id="pf" value={registerFormData.pf} onChange={inputHandler} />
                        </div>
                        </div>
                        <h3 className="text-center" style={{ color: 'black', backgroundColor: '#e5eaef', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <i className="fa-solid fa-indian-rupee-sign" aria-hidden="true" style={{ color: 'red' }}></i>
                          Salary Details
                        </h3>
                         <div className="row">
                        <div className="col-md-3 mb-3">
                            <label htmlFor="Basic Salary" className="form-label">Basic Salary</label>
                            <input type="number" placeholder="Basic Salary" className="form-control"
                               name="basic" id="basic" value={registerFormData.basic} onChange={inputHandler} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="HRA" className="form-label">HRA</label>
                            <input type="number" placeholder="HRA" className="form-control" maxLength={16}
                               name="hra" id="hra" value={registerFormData.hra} onChange={inputHandler} />
                        </div>
                        <div className="col-md-2 mb-3">
                            <label htmlFor="Allowance" className="form-label">Allowance</label>
                            <input type="number" placeholder="Allowance" className="form-control" maxLength={16}
                               name="allowance" id="allowance" value={registerFormData.allowance} onChange={inputHandler} />
                        </div>
                        <div className="col-md-2 mb-3">
                            <label htmlFor="Spl Allowance" className="form-label">Spl Allowance</label>
                            <input type="number" placeholder="Spl Allowance" className="form-control" maxLength={20}
                               name="spl" id="spl" value={registerFormData.spl} onChange={inputHandler} />
                        </div>
                        <div className="col-md-2 mb-3">
                            <label htmlFor="Other Earnings" className="form-label">Other Earnings</label>
                            <input type="number" placeholder="Other Earnings" className="form-control"
                               name="other_earn" id="other_earn" value={registerFormData.other_earn} onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-6 mb-3">
                            <label htmlFor="Earnings per Month" className="form-label">Earnings per Month</label>
                            <input type="number" placeholder="Earnings per Month" className="form-control"
                               name="earnings" id="earnings" value={registerFormData.earnings} onChange={inputHandler} readOnly/>
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-2 mb-2">
                            <label htmlFor="Prof Tax" className="form-label">Prof Tax</label>
                            <input type="number" placeholder="Prof Tax" className="form-control" maxLength={16}
                               name="prof" id="prof" value={registerFormData.prof} onChange={inputHandler} />
                        </div>
                        <div className="col-md-2 mb-2">
                            <label htmlFor="TDS" className="form-label">TDS</label>
                            <input type="number" placeholder="TDS" className="form-control" maxLength={20}
                               name="tds" id="tds" value={registerFormData.tds} onChange={inputHandler} />
                        </div>
                        <div className="col-md-2 mb-2">
                            <label htmlFor="Other Deduction" className="form-label">Other Deduction</label>
                            <input type="number" placeholder="Other Deduction" className="form-control" maxLength={16}
                               name="other_deduct" id="other_deduct" value={registerFormData.other_deduct} onChange={inputHandler} />
                        </div>
                        <div className="col-md-3 mb-2">
                            <label htmlFor="TDS" className="form-label">Employee PF Contri. @12%</label>
                            <input type="number" placeholder="TDS" className="form-control" maxLength={20}
                               name="empf" id="empf" value={registerFormData.empf} onChange={inputHandler} />
                        </div>
                        <div className="col-md-3 mb-2">
                            <label htmlFor="Empl ESI" className="form-label">Employee ESI @0.75%</label>
                            <input type="number" placeholder="Empl ESI" className="form-control" maxLength={20}
                               name="emesi" id="emesi" value={registerFormData.emesi} onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-6 mb-3">
                            <label htmlFor="Total Deduction per Month" className="form-label">Total Deduction per Month</label>
                            <input type="number" placeholder="Total Deduction per Month" className="form-control"
                               name="deduction" id="deduction" value={registerFormData.deduction} onChange={inputHandler} readOnly/>
                        </div>
                        <div className="col-md-6 mb-3">
                            <label htmlFor="Total CTC per Month" className="form-label">Total CTC per Month</label>
                            <input type="number" placeholder="Total CTC per Month" className="form-control"
                               name="ctc" id="ctc" value={registerFormData.ctc} onChange={inputHandler} readOnly/>
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-12 text-center">
                        <button type="button" onClick={submitHandler}
                        className="btn btn-success">Register</button>
                        </div>
                        </div>
                        </div>
                        </form>
                    </div>
                </div>
              </div>
            </div>
        </section>
  );
}

export default AddEmployee;
